// source: witbooking/backoffice/loyalty/tier/v1/loyalty_tier_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var validate_validate_pb = require('../../../../../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var google_type_money_pb = require('../../../../../google/type/money_pb.js');
goog.object.extend(proto, google_type_money_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyFixedAmountDiscount', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPercentageDiscount', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscountType', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.ConditionCase', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.TierCase', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest.displayName = 'proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierResponse.displayName = 'proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest.displayName = 'proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierResponse.displayName = 'proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest.displayName = 'proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierResponse.displayName = 'proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest.displayName = 'proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse.displayName = 'proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandRequest.displayName = 'proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse.displayName = 'proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest.displayName = 'proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierResponse.displayName = 'proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest.displayName = 'proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierResponse.displayName = 'proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.displayName = 'proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.displayName = 'proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount.displayName = 'proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyFixedAmountDiscount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyFixedAmountDiscount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyFixedAmountDiscount.displayName = 'proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyFixedAmountDiscount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPercentageDiscount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPercentageDiscount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPercentageDiscount.displayName = 'proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPercentageDiscount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet.displayName = 'proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.oneofGroups_);
};
goog.inherits(proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.displayName = 'proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule.displayName = 'proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule.displayName = 'proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule.displayName = 'proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.displayName = 'proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.oneofGroups_);
};
goog.inherits(proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.displayName = 'proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    brandTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    tier: (f = msg.getTier()) && proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest}
 */
proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest;
  return proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest}
 */
proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandTicker(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier;
      reader.readMessage(value,proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.deserializeBinaryFromReader);
      msg.setTier(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrandTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTier();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.serializeBinaryToWriter
    );
  }
};


/**
 * optional string brand_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest.prototype.getBrandTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest.prototype.setBrandTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional LoyaltyTier tier = 2;
 * @return {?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier}
 */
proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest.prototype.getTier = function() {
  return /** @type{?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier, 2));
};


/**
 * @param {?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier|undefined} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest} returns this
*/
proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest.prototype.setTier = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest.prototype.clearTier = function() {
  return this.setTier(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierRequest.prototype.hasTier = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierResponse}
 */
proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierResponse;
  return proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierResponse}
 */
proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.CreateLoyaltyTierResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    brandTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    tier: (f = msg.getTier()) && proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest}
 */
proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest;
  return proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest}
 */
proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandTicker(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier;
      reader.readMessage(value,proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.deserializeBinaryFromReader);
      msg.setTier(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrandTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTier();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.serializeBinaryToWriter
    );
  }
};


/**
 * optional string brand_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest.prototype.getBrandTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest.prototype.setBrandTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional LoyaltyTier tier = 2;
 * @return {?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier}
 */
proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest.prototype.getTier = function() {
  return /** @type{?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier, 2));
};


/**
 * @param {?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier|undefined} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest} returns this
*/
proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest.prototype.setTier = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest.prototype.clearTier = function() {
  return this.setTier(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierRequest.prototype.hasTier = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierResponse}
 */
proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierResponse;
  return proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierResponse}
 */
proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.UpdateLoyaltyTierResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    brandTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest}
 */
proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest;
  return proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest}
 */
proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandTicker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrandTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string brand_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest.prototype.getBrandTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest.prototype.setBrandTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierResponse}
 */
proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierResponse;
  return proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierResponse}
 */
proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.DeleteLoyaltyTierResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    brandTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest}
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest;
  return proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest}
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandTicker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrandTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string brand_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest.prototype.getBrandTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest.prototype.setBrandTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    tier: (f = msg.getTier()) && proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse}
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse;
  return proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse}
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier;
      reader.readMessage(value,proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.deserializeBinaryFromReader);
      msg.setTier(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTier();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.serializeBinaryToWriter
    );
  }
};


/**
 * optional LoyaltyTier tier = 1;
 * @return {?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier}
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse.prototype.getTier = function() {
  return /** @type{?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier, 1));
};


/**
 * @param {?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier|undefined} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse} returns this
*/
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse.prototype.setTier = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse.prototype.clearTier = function() {
  return this.setTier(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTierResponse.prototype.hasTier = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    brandTicker: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandRequest}
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandRequest;
  return proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandRequest}
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrandTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string brand_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandRequest.prototype.getBrandTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandRequest} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandRequest.prototype.setBrandTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    tiersList: jspb.Message.toObjectList(msg.getTiersList(),
    proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.toObject, includeInstance),
    promotedTier: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse}
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse;
  return proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse}
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier;
      reader.readMessage(value,proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.deserializeBinaryFromReader);
      msg.addTiers(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPromotedTier(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTiersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.serializeBinaryToWriter
    );
  }
  f = message.getPromotedTier();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated LoyaltyTier tiers = 1;
 * @return {!Array<!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier>}
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse.prototype.getTiersList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier>} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse} returns this
*/
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse.prototype.setTiersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier}
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse.prototype.addTiers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse.prototype.clearTiersList = function() {
  return this.setTiersList([]);
};


/**
 * optional string promoted_tier = 2;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse.prototype.getPromotedTier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.GetLoyaltyTiersByBrandResponse.prototype.setPromotedTier = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    brandTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, ""),
    after: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest}
 */
proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest;
  return proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest}
 */
proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandTicker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAfter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrandTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAfter();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string brand_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest.prototype.getBrandTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest.prototype.setBrandTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string after = 3;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest.prototype.getAfter = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierRequest.prototype.setAfter = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierResponse}
 */
proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierResponse;
  return proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierResponse}
 */
proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.ReorderLoyaltyTierResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    brandTicker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, ""),
    promote: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest}
 */
proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest;
  return proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest}
 */
proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandTicker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPromote(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrandTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPromote();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string brand_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest.prototype.getBrandTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest.prototype.setBrandTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool promote = 3;
 * @return {boolean}
 */
proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest.prototype.getPromote = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierRequest.prototype.setPromote = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierResponse}
 */
proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierResponse;
  return proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierResponse}
 */
proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.PromoteLoyaltyTierResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.repeatedFields_ = [3,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ticker: jspb.Message.getFieldWithDefault(msg, 2, ""),
    translationsList: jspb.Message.toObjectList(msg.getTranslationsList(),
    proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.toObject, includeInstance),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    rgbaColor: jspb.Message.getFieldWithDefault(msg, 6, ""),
    promotedDiscount: (f = msg.getPromotedDiscount()) && proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount.toObject(includeInstance, f),
    promoCodesList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    externalSystemId: jspb.Message.getFieldWithDefault(msg, 9, ""),
    inUse: jspb.Message.getBooleanFieldWithDefault(msg, 10, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier;
  return proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 3:
      var value = new proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation;
      reader.readMessage(value,proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.deserializeBinaryFromReader);
      msg.addTranslations(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setRgbaColor(value);
      break;
    case 7:
      var value = new proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount;
      reader.readMessage(value,proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount.deserializeBinaryFromReader);
      msg.setPromotedDiscount(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addPromoCodes(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalSystemId(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInUse(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTranslationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getRgbaColor();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPromotedDiscount();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount.serializeBinaryToWriter
    );
  }
  f = message.getPromoCodesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getExternalSystemId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getInUse();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ticker = 2;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated LoyaltyTierTranslation translations = 3;
 * @return {!Array<!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation>}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.getTranslationsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation, 3));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation>} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier} returns this
*/
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.setTranslationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.addTranslations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.clearTranslationsList = function() {
  return this.setTranslationsList([]);
};


/**
 * optional google.protobuf.Timestamp created_at = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier} returns this
*/
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier} returns this
*/
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string rgba_color = 6;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.getRgbaColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.setRgbaColor = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional LoyaltyPromotedDiscount promoted_discount = 7;
 * @return {?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.getPromotedDiscount = function() {
  return /** @type{?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount, 7));
};


/**
 * @param {?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount|undefined} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier} returns this
*/
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.setPromotedDiscount = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.clearPromotedDiscount = function() {
  return this.setPromotedDiscount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.hasPromotedDiscount = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * repeated string promo_codes = 8;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.getPromoCodesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.setPromoCodesList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.addPromoCodes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.clearPromoCodesList = function() {
  return this.setPromoCodesList([]);
};


/**
 * optional string external_system_id = 9;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.getExternalSystemId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.setExternalSystemId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional bool in_use = 10;
 * @return {boolean}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.getInUse = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.prototype.setInUse = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.repeatedFields_ = [3,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ticker: jspb.Message.getFieldWithDefault(msg, 2, ""),
    translationsList: jspb.Message.toObjectList(msg.getTranslationsList(),
    proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.toObject, includeInstance),
    conditions: (f = msg.getConditions()) && proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet.toObject(includeInstance, f),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    rgbaColor: jspb.Message.getFieldWithDefault(msg, 7, ""),
    promotedDiscount: (f = msg.getPromotedDiscount()) && proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount.toObject(includeInstance, f),
    promoCodesList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
    externalSystemId: jspb.Message.getFieldWithDefault(msg, 10, ""),
    inUse: jspb.Message.getBooleanFieldWithDefault(msg, 11, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier;
  return proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 3:
      var value = new proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation;
      reader.readMessage(value,proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.deserializeBinaryFromReader);
      msg.addTranslations(value);
      break;
    case 4:
      var value = new proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet;
      reader.readMessage(value,proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet.deserializeBinaryFromReader);
      msg.setConditions(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setRgbaColor(value);
      break;
    case 8:
      var value = new proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount;
      reader.readMessage(value,proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount.deserializeBinaryFromReader);
      msg.setPromotedDiscount(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addPromoCodes(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalSystemId(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInUse(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTranslationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.serializeBinaryToWriter
    );
  }
  f = message.getConditions();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getRgbaColor();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPromotedDiscount();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount.serializeBinaryToWriter
    );
  }
  f = message.getPromoCodesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
  f = message.getExternalSystemId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getInUse();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ticker = 2;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated LoyaltyTierTranslation translations = 3;
 * @return {!Array<!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation>}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.getTranslationsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation, 3));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation>} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier} returns this
*/
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.setTranslationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.addTranslations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.clearTranslationsList = function() {
  return this.setTranslationsList([]);
};


/**
 * optional LoyaltyRuleSet conditions = 4;
 * @return {?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.getConditions = function() {
  return /** @type{?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet, 4));
};


/**
 * @param {?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet|undefined} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier} returns this
*/
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.setConditions = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.clearConditions = function() {
  return this.setConditions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.hasConditions = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp created_at = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier} returns this
*/
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier} returns this
*/
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string rgba_color = 7;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.getRgbaColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.setRgbaColor = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional LoyaltyPromotedDiscount promoted_discount = 8;
 * @return {?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.getPromotedDiscount = function() {
  return /** @type{?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount, 8));
};


/**
 * @param {?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount|undefined} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier} returns this
*/
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.setPromotedDiscount = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.clearPromotedDiscount = function() {
  return this.setPromotedDiscount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.hasPromotedDiscount = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * repeated string promo_codes = 9;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.getPromoCodesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.setPromoCodesList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.addPromoCodes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.clearPromoCodesList = function() {
  return this.setPromoCodesList([]);
};


/**
 * optional string external_system_id = 10;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.getExternalSystemId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.setExternalSystemId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional bool in_use = 11;
 * @return {boolean}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.getInUse = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.prototype.setInUse = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount.toObject = function(includeInstance, msg) {
  var f, obj = {
    amount: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    type: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount;
  return proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setAmount(value);
      break;
    case 2:
      var value = /** @type {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscountType} */ (reader.readEnum());
      msg.setType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmount();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional float amount = 1;
 * @return {number}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount.prototype.setAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional LoyaltyPromotedDiscountType type = 2;
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscountType}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount.prototype.getType = function() {
  return /** @type {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscountType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscountType} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscount.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyFixedAmountDiscount.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyFixedAmountDiscount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyFixedAmountDiscount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyFixedAmountDiscount.toObject = function(includeInstance, msg) {
  var f, obj = {
    amount: (f = msg.getAmount()) && google_type_money_pb.Money.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyFixedAmountDiscount}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyFixedAmountDiscount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyFixedAmountDiscount;
  return proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyFixedAmountDiscount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyFixedAmountDiscount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyFixedAmountDiscount}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyFixedAmountDiscount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyFixedAmountDiscount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyFixedAmountDiscount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyFixedAmountDiscount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyFixedAmountDiscount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.type.Money amount = 1;
 * @return {?proto.google.type.Money}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyFixedAmountDiscount.prototype.getAmount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 1));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyFixedAmountDiscount} returns this
*/
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyFixedAmountDiscount.prototype.setAmount = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyFixedAmountDiscount} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyFixedAmountDiscount.prototype.clearAmount = function() {
  return this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyFixedAmountDiscount.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPercentageDiscount.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPercentageDiscount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPercentageDiscount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPercentageDiscount.toObject = function(includeInstance, msg) {
  var f, obj = {
    amount: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPercentageDiscount}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPercentageDiscount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPercentageDiscount;
  return proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPercentageDiscount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPercentageDiscount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPercentageDiscount}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPercentageDiscount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPercentageDiscount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPercentageDiscount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPercentageDiscount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPercentageDiscount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmount();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
};


/**
 * optional float amount = 1;
 * @return {number}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPercentageDiscount.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPercentageDiscount} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPercentageDiscount.prototype.setAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet.toObject = function(includeInstance, msg) {
  var f, obj = {
    conditionsList: jspb.Message.toObjectList(msg.getConditionsList(),
    proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.toObject, includeInstance),
    allConditionsMustBeMet: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet;
  return proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule;
      reader.readMessage(value,proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.deserializeBinaryFromReader);
      msg.addConditions(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllConditionsMustBeMet(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConditionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.serializeBinaryToWriter
    );
  }
  f = message.getAllConditionsMustBeMet();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * repeated LoyaltyRule conditions = 1;
 * @return {!Array<!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule>}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet.prototype.getConditionsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule>} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet} returns this
*/
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet.prototype.setConditionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet.prototype.addConditions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet.prototype.clearConditionsList = function() {
  return this.setConditionsList([]);
};


/**
 * optional bool all_conditions_must_be_met = 2;
 * @return {boolean}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet.prototype.getAllConditionsMustBeMet = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRuleSet.prototype.setAllConditionsMustBeMet = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.ConditionCase = {
  CONDITION_NOT_SET: 0,
  POINTS_CONDITION: 1,
  SPENT_AMOUNT_CONDITION: 2,
  PURCHASES_AMOUNT_CONDITION: 3
};

/**
 * @return {proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.ConditionCase}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.prototype.getConditionCase = function() {
  return /** @type {proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.ConditionCase} */(jspb.Message.computeOneofCase(this, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.toObject = function(includeInstance, msg) {
  var f, obj = {
    pointsCondition: (f = msg.getPointsCondition()) && proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule.toObject(includeInstance, f),
    spentAmountCondition: (f = msg.getSpentAmountCondition()) && proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule.toObject(includeInstance, f),
    purchasesAmountCondition: (f = msg.getPurchasesAmountCondition()) && proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule;
  return proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule;
      reader.readMessage(value,proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule.deserializeBinaryFromReader);
      msg.setPointsCondition(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule;
      reader.readMessage(value,proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule.deserializeBinaryFromReader);
      msg.setSpentAmountCondition(value);
      break;
    case 3:
      var value = new proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule;
      reader.readMessage(value,proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule.deserializeBinaryFromReader);
      msg.setPurchasesAmountCondition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPointsCondition();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule.serializeBinaryToWriter
    );
  }
  f = message.getSpentAmountCondition();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule.serializeBinaryToWriter
    );
  }
  f = message.getPurchasesAmountCondition();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule.serializeBinaryToWriter
    );
  }
};


/**
 * optional LoyaltyPointsRule points_condition = 1;
 * @return {?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.prototype.getPointsCondition = function() {
  return /** @type{?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule, 1));
};


/**
 * @param {?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule|undefined} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule} returns this
*/
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.prototype.setPointsCondition = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.prototype.clearPointsCondition = function() {
  return this.setPointsCondition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.prototype.hasPointsCondition = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional LoyaltySpentAmountRule spent_amount_condition = 2;
 * @return {?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.prototype.getSpentAmountCondition = function() {
  return /** @type{?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule, 2));
};


/**
 * @param {?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule|undefined} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule} returns this
*/
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.prototype.setSpentAmountCondition = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.prototype.clearSpentAmountCondition = function() {
  return this.setSpentAmountCondition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.prototype.hasSpentAmountCondition = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional LoyaltyTransactionsAmountRule purchases_amount_condition = 3;
 * @return {?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.prototype.getPurchasesAmountCondition = function() {
  return /** @type{?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule, 3));
};


/**
 * @param {?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule|undefined} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule} returns this
*/
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.prototype.setPurchasesAmountCondition = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.prototype.clearPurchasesAmountCondition = function() {
  return this.setPurchasesAmountCondition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyRule.prototype.hasPurchasesAmountCondition = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule.toObject = function(includeInstance, msg) {
  var f, obj = {
    amount: jspb.Message.getFieldWithDefault(msg, 1, 0),
    contextKeysList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule;
  return proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAmount(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addContextKeys(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getContextKeysList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional int32 amount = 1;
 * @return {number}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated string context_keys = 2;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule.prototype.getContextKeysList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule.prototype.setContextKeysList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule.prototype.addContextKeys = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPointsRule.prototype.clearContextKeysList = function() {
  return this.setContextKeysList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule.toObject = function(includeInstance, msg) {
  var f, obj = {
    amount: (f = msg.getAmount()) && google_type_money_pb.Money.toObject(includeInstance, f),
    contextKeysList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule;
  return proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_type_money_pb.Money;
      reader.readMessage(value,google_type_money_pb.Money.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addContextKeys(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_type_money_pb.Money.serializeBinaryToWriter
    );
  }
  f = message.getContextKeysList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional google.type.Money amount = 1;
 * @return {?proto.google.type.Money}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule.prototype.getAmount = function() {
  return /** @type{?proto.google.type.Money} */ (
    jspb.Message.getWrapperField(this, google_type_money_pb.Money, 1));
};


/**
 * @param {?proto.google.type.Money|undefined} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule} returns this
*/
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule.prototype.setAmount = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule.prototype.clearAmount = function() {
  return this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated string context_keys = 2;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule.prototype.getContextKeysList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule.prototype.setContextKeysList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule.prototype.addContextKeys = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltySpentAmountRule.prototype.clearContextKeysList = function() {
  return this.setContextKeysList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule.toObject = function(includeInstance, msg) {
  var f, obj = {
    amount: jspb.Message.getFieldWithDefault(msg, 1, 0),
    contextKeysList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule;
  return proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAmount(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addContextKeys(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getContextKeysList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional int32 amount = 1;
 * @return {number}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated string context_keys = 2;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule.prototype.getContextKeysList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule.prototype.setContextKeysList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule.prototype.addContextKeys = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTransactionsAmountRule.prototype.clearContextKeysList = function() {
  return this.setContextKeysList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.toObject = function(includeInstance, msg) {
  var f, obj = {
    locale: jspb.Message.getFieldWithDefault(msg, 1, ""),
    highlightedNameTop: jspb.Message.getFieldWithDefault(msg, 2, ""),
    highlightedNameBottom: jspb.Message.getFieldWithDefault(msg, 3, ""),
    highlightedTextTop: jspb.Message.getFieldWithDefault(msg, 4, ""),
    highlightedTextBottom: jspb.Message.getFieldWithDefault(msg, 5, ""),
    name: jspb.Message.getFieldWithDefault(msg, 6, ""),
    description: jspb.Message.getFieldWithDefault(msg, 7, ""),
    benefitDescription: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation;
  return proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocale(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setHighlightedNameTop(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setHighlightedNameBottom(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setHighlightedTextTop(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setHighlightedTextBottom(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setBenefitDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocale();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHighlightedNameTop();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getHighlightedNameBottom();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getHighlightedTextTop();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getHighlightedTextBottom();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getBenefitDescription();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string locale = 1;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.prototype.getLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.prototype.setLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string highlighted_name_top = 2;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.prototype.getHighlightedNameTop = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.prototype.setHighlightedNameTop = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string highlighted_name_bottom = 3;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.prototype.getHighlightedNameBottom = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.prototype.setHighlightedNameBottom = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string highlighted_text_top = 4;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.prototype.getHighlightedTextTop = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.prototype.setHighlightedTextTop = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string highlighted_text_bottom = 5;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.prototype.getHighlightedTextBottom = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.prototype.setHighlightedTextBottom = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string name = 6;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string description = 7;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string benefit_description = 8;
 * @return {string}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.prototype.getBenefitDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTierTranslation.prototype.setBenefitDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.TierCase = {
  TIER_NOT_SET: 0,
  CONSTANT_TIER: 1,
  DERIVED_TIER: 2
};

/**
 * @return {proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.TierCase}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.prototype.getTierCase = function() {
  return /** @type {proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.TierCase} */(jspb.Message.computeOneofCase(this, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.toObject = function(includeInstance, msg) {
  var f, obj = {
    constantTier: (f = msg.getConstantTier()) && proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.toObject(includeInstance, f),
    derivedTier: (f = msg.getDerivedTier()) && proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier;
  return proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier;
      reader.readMessage(value,proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.deserializeBinaryFromReader);
      msg.setConstantTier(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier;
      reader.readMessage(value,proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.deserializeBinaryFromReader);
      msg.setDerivedTier(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConstantTier();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier.serializeBinaryToWriter
    );
  }
  f = message.getDerivedTier();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier.serializeBinaryToWriter
    );
  }
};


/**
 * optional LoyaltyConstantTier constant_tier = 1;
 * @return {?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.prototype.getConstantTier = function() {
  return /** @type{?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier, 1));
};


/**
 * @param {?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyConstantTier|undefined} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier} returns this
*/
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.prototype.setConstantTier = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.prototype.clearConstantTier = function() {
  return this.setConstantTier(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.prototype.hasConstantTier = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional LoyaltyDerivedTier derived_tier = 2;
 * @return {?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.prototype.getDerivedTier = function() {
  return /** @type{?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier, 2));
};


/**
 * @param {?proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyDerivedTier|undefined} value
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier} returns this
*/
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.prototype.setDerivedTier = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier} returns this
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.prototype.clearDerivedTier = function() {
  return this.setDerivedTier(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyTier.prototype.hasDerivedTier = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * @enum {number}
 */
proto.witbooking.backoffice.loyalty.tier.v1.LoyaltyPromotedDiscountType = {
  PERCENTAGE: 0,
  CONSTANT: 1
};

goog.object.extend(exports, proto.witbooking.backoffice.loyalty.tier.v1);
